export default __webpack_public_path__ + "static/media/ic_avalanche_24.264543fb.svg";